import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const TextBold = styled.div`
    font-family: AvenirNextWorld Bold;
    font-size: ${(props) => props.fontSize};
`;
export const TextRegular = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${(props) => props.fontSize};
`;
export const TextDemi = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: ${(props) => props.fontSize};
    margin: ${(props) => props.margin};
`;
export const CasesForTheDayColumn = styled.div`
    min-height: 100%;
    min-width: 148.87px !important;
    margin-right: 4px;
    // overflow-y: scroll !important;
    &::-webkit-scrollbar {
        display: none;
    }
    /* background-color: lightgrey; */
    /* ${media.smalDevice`
		height: 900px;
	`} */
`;
